import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  loggedUserIdSelector,
  targetUserIdSelector,
} from '../../../../redux/context/selectors';

export const useChartActions = ({ actions, modalActions }) => {
  const dispatch = useDispatch();
  const [isModal, setModalVisible] = useState(false);
  const [baseDate, setBaseDate] = useState(null);

  const targetUserId = useSelector(targetUserIdSelector);
  const loggedUserId = useSelector(loggedUserIdSelector);

  const userId = targetUserId || loggedUserId;

  const loadPeriod = ({ period }) => dispatch(actions.send({ userId, period }));

  const openDay = ({ date }) => {
    setModalVisible(true);
    setBaseDate(date);
    dispatch(modalActions.send({ userId, baseDate: date, period: 'day' }));
  };

  const closeDay = () => {
    setModalVisible(false);
    setBaseDate(null);
    dispatch(modalActions.clear());
  };

  return { isModal, openDay, closeDay, baseDate, loadPeriod };
};



// WEBPACK FOOTER //
// ./src/components/common/Charts/hooks/useChartActions.js